<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Dana Penjualan</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listEwallet" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationEwallet.total_data">
				<template v-slot:item.ewallet_balance="{ item }">
					{{ item.ewallet_balance | toRupiah }}
				</template>
				<template v-slot:item.ewallet_hold="{ item }">
					{{ item.ewallet_hold == true ? 'Tertahan' : 'Tersedia' }}
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationEwallet">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationEwallet">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationEwallet.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationEwallet.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'

const list_status = [{
	value: 'tersedia',
	text: 'Tersedia'
}, {
	value: 'tertahan',
	text: 'Tertahan'
}];

export default {
	inject: ['theme'],
	components: {
		filterComponent
	},
	data() {
		return {
			sortBy: 'ewallet_balance',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Kode Stockist', align: 'start', value: 'stockist_code'},
			{ text: 'Nama Stockist', align: 'start', value: 'stockist_name'},
			{ text: 'Dana Penjualan', align: 'start', value: 'ewallet_balance'},
			{ text: 'Status', value: 'ewallet_hold'},
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_code'
				}
			}, {
				type: 'text',
				label: 'Nama Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_name'
				}
			}, {
				type: 'selection',
				label: 'Status',
				item: list_status,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'ewallet_hold'
				}
			},
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceEwallet', ['listEwallet', 'paginationEwallet']),
	},
	methods: {
		...mapActions('ecommerceEwallet', ['getEwallet', 'exportEwallet']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceEwallet', ['clearDataEwallet']),

		getData() {
			this.getEwallet(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			this.exportEwallet(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
	},
	beforeDestroy(){
		this.clearDataEwallet()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Ewallet Ecommerce`)
		await this.getData()

		await this.setFilter(this.filterData)
	},
};
</script>

<style>
